
import { mapState } from "vuex";

import { getVariantTitle } from "~/utils/shopify-utils";
import { tagableMixin, metaColourMixin } from "~/mixins";

export default {
  mixins: [tagableMixin, metaColourMixin],

  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
    tags: { type: Array, default: () => [] },
    priorityCampaign: { type: Object, default: () => {} },
    maxDiscount: { type: [Number, String], default: 0 },
    colorVariantTile: { type: Object, required: true },
    inStoreColorsText: { type: String, default: "" },
  },

  computed: {
    ...mapState("app", ["topBannerHeight"]),
    title() {
      return `${this.product.title} ${getVariantTitle({
        isMultiVariant: this.isMultiVariant,
        variant: this.selectedVariant,
      })}`;
    },
    productPriceProps() {
      return {
        isBundleProduct: this.isBundleProduct,
        priorityCampaign: this.priorityCampaign,
        selectedVariant: this.selectedVariant,
        maxDiscount: this.maxDiscount,
      };
    },
    colorTiles() {
      return this.colorVariantTile?.tiles.filter(
        tile => tile.targetVariantId !== null
      );
    },
    instoreColorsText() {
      return this.hasMoreColorsInstore && this.inStoreColorsText
        ? this.inStoreColorsText
        : "";
    },
  },

  methods: {
    scrollToReviews() {
      const $reviewContainer = document.getElementById("review-container");
      if ($reviewContainer) {
        // const scrollHeight =
        //   $reviewContainer.offsetTop - this.$refs["main-info"].offsetTop;
        const pdpStickyHeaderHeight = 80;
        window.scrollTo({
          top:
            $reviewContainer.offsetTop -
            this.topBannerHeight -
            pdpStickyHeaderHeight,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
